module.exports = __webpack_public_path__ + "img/iconTowedCar1.a54d88dd.svg";